import { FormQua042 } from './../../entity/forms/form-qua042';
import { FormularioService } from './../../services/formulario.service';
import { NotificationService } from './../../services/notification.service';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Component, OnInit, ViewChild, AfterViewInit } from '@angular/core';
import { CabecalhoDTO } from 'src/app/entity/dto/cabecalho.component';
import { GeneralService } from 'src/app/services/general.service';
import { Qua042CardIComponent } from './partialViews/qua042-card-I.component';
import { Qua042CardIIComponent } from './partialViews/qua042-card-II.component';
import { Qua042CardIIIComponent } from './partialViews/qua042-card-III.component';
import { HttpErrorResponse } from '@angular/common/http';
import { ActivatedRoute } from '@angular/router';
import { EnumFormType } from 'src/app/entity/enum/enum-form-type';
import { BehaviorSubject } from 'rxjs';
import { EnumForm } from 'src/app/entity/enum/enum-form';
import { take } from 'rxjs/operators';
import { ActionMessage, TypeMessage } from 'src/app/entity/enum/enum-notification';
import { MatDialog } from '@angular/material/dialog';
import { FormModalConfirmComponent } from 'src/app/shared/form-modal-confirm/form-modal-confirm.component';
import { ResumeAllFormsService } from 'src/app/services/resume-all-forms.service';
import * as moment from 'moment';

@Component({
  selector: 'app-form-qua042',
  templateUrl: './form-qua042.component.html'
})

export class FormQua042Component implements OnInit, AfterViewInit {
  public areaSelect: string = localStorage.getItem('area-select') || null;
  public header?: CabecalhoDTO;
  public formulario?: FormGroup;
  public btnCollapse?: boolean;
  private loadingSubject = new BehaviorSubject<boolean>(false);
  public enableButtons = this.loadingSubject.asObservable();
  public showButtonSync = false;
  public formQua042: FormQua042 = new FormQua042();
  valuesInitial: any;
  valoresAlterados: any[] = [];
  currentUser: string = "";
  dict = {
    "M2": "1222",
    "M6": "1183",
    "M4": "1173",
    "SHG": "1076",
    "M7": "1040",
    "CDR": "1160",
    "PTU-BÁSICA": "1040",
    "CVE": "1222",
    "UDI": "1183",
    "ITA": "1173",
    "PTU": "1040"
  };
  codigoEmbalage = [
    {
      "modelo": "Genética",
      "tamanho": "P",
      "codigo": 30253945
    },
    {
      "modelo": "Genética",
      "tamanho": "M",
      "codigo": 30253946
    },
    {
      "modelo": "Genética",
      "tamanho": "G",
      "codigo": 30159535
    },
    {
      "modelo": "Experimental",
      "tamanho": "P",
      "codigo": 30159536
    },
    {
      "modelo": "Experimental",
      "tamanho": "M",
      "codigo": 30159537
    },
    {
      "modelo": "Experimental",
      "tamanho": "G",
      "codigo": 30159538
    }
  ]


  @ViewChild(Qua042CardIComponent, { static: false }) qua042CardIComponent: Qua042CardIComponent;
  @ViewChild(Qua042CardIIComponent, { static: false }) qua042CardIIComponent: Qua042CardIIComponent;
  @ViewChild(Qua042CardIIIComponent, { static: false }) qua042CardIIIComponent: Qua042CardIIIComponent;

  // tslint:disable-next-line: max-line-length
  constructor(protected formBuilder: FormBuilder, protected generalService: GeneralService, protected notificationService: NotificationService, protected formularioService: FormularioService, protected route: ActivatedRoute, protected resumeAllFormsService: ResumeAllFormsService, public dialog: MatDialog) {
    this.formulario = this.formQua042.CreateForm(formBuilder);
  }

  ngAfterViewInit(): void {
    this.route.data.subscribe(async (data: any) => {
      if (!!data) {
        this.valuesInitial = data?.formulario ?? this.formulario.getRawValue();;
        const type = (this.route?.snapshot?.params?.type);
        const isReadOnly: boolean = type === '2' ? true : false;
        this.loadingSubject.next(isReadOnly ? false : true);
        if (type === '1' || type === '2') {
          if (type === '1') {
            this.header = this.generalService.createHeader(EnumForm.FormQua042, EnumFormType.Edit);
          } else {
            this.header = this.generalService.createHeader(EnumForm.FormQua042, EnumFormType.Details);
          }
          if (data.formulario.offline) {
            this.showButtonSync = true;
          }
          this.updateForm(data);
        } else {

          await this.getUser();
          this.fillCreatedByFormField();
          this.header = this.generalService.createHeader(EnumForm.FormQua042, EnumFormType.New);
          this.qua042CardIComponent.formulario.get('centro_ensaque').setValue(this.generalService.getCentroEnsaqueByLocalStorageDataSite());
        }
      }
    });
  }


  ngOnInit(): void {
    // tslint:disable-next-line: max-line-length
    this.header = this.generalService.createHeader(EnumForm.FormQua042, EnumFormType.New);
    this.btnCollapse = true;
    this.loadingSubject.next(false);
  }


  public makeCalculations(event?: any): void {
    this.calcDuracaoAtvEnsaque();
    this.calcPeneiraEGrupoPeneira()
    this.getTotalPerdasEmbalagens();
    this.calcTotalSacos();
    this.calcPesoTotalDoLote();
    this.calcQuantidadeDeEmablagens();

  }

  async save(): Promise<void> {
    const id: number = this.formulario.get('id').value as number ?? 0;
    const isAddFlow = id === 0;
    if (this.validFormsToSave() === '') {
      this.buildFormulario();

      this.formulario.get('origem_negocio').setValue(String(this.generalService.areaSelect));
      await this.resumeAllFormsService.compareAdd(this.valuesInitial, this.formulario.getRawValue(), isAddFlow, 'qua042');
      this.openConfirmDialog(this.resumeAllFormsService.valoresAlterados, isAddFlow);
    }
  }



  public openConfirmDialog(valoresAlterados: any[], isAddFlow): void {
    const values: any[] = valoresAlterados;
    const dialogRef = this.dialog.open(FormModalConfirmComponent, {
      data: {
        valoresAlterados: values,
        isAddFlow
      }
    });
    dialogRef.afterClosed().subscribe(x => {
      if (x.save) {
        const id: number = this.formulario.get('id').value as number;
        this.formularioService.saveForm(id, this.formulario.getRawValue(), 'qua042', 'formqua042');
      }
      else {
        this.resumeAllFormsService.valoresAlterados = [];
      }
    })
  }


  getPC003DataFromFieldNumber($event: { safra: string, numeroCampo: string }): void {
    this.formularioService.getPc003Data(null, $event.safra, $event.numeroCampo).pipe(take(1)).toPromise().then((objPC003: any) => {
      this.qua042CardIComponent?.formulario.get('contrato_juridico').setValue(objPC003?.data?.contrato_juridico);
      this.qua042CardIComponent?.formulario.get('hibrido_rnc').setValue(objPC003?.data?.hibrido_rnc);
      this.qua042CardIComponent?.formulario.get('especie').setValue(objPC003?.data?.especie);
      this.qua042CardIComponent?.formulario.get('geracao').setValue(objPC003?.data?.geracao);
    });
  }

  // .pipe(take(1)).toPromise().then((objPC003: any) => {
  //   this.cd003CardIComponent?.formulario.get('hibrido_rnc').setValue(objPC003?.data?.hibrido_rnc);
  //   this.cd003CardIComponent?.formulario.get('contrato_juridico').setValue(objPC003?.data?.contrato_juridico);
  //   this.cd003CardIComponent?.formulario.get('prioridade').setValue(objPC003?.data?.jit);
  //   this.cd003CardIComponent?.formulario.get('geracao').setValue(objPC003?.data?.geracao);


  geracaoCodigoEmbalagem() {
    const tamanho_da_sacaria = this.qua042CardIIIComponent.formulario.get("tamanho_da_sacaria").value
    const geracao = this.qua042CardIComponent.formulario.get("geracao").value
    this.qua042CardIIIComponent.formulario.get("codigo_embalagem").setValue("")
    if ((geracao != '' && geracao != null) && (tamanho_da_sacaria != '' && tamanho_da_sacaria != null && tamanho_da_sacaria != '20 KG')) {
      if (geracao == 'G1' || geracao == "G2" || geracao == "G3" || geracao == "G4") {
        const codigo = this.codigoEmbalage.filter(ce => ce.modelo == 'Genética' && ce.tamanho == tamanho_da_sacaria)[0].codigo

        this.qua042CardIIIComponent.formulario.get("codigo_embalagem").setValue(codigo)
      }
      else {
        const codigo = this.codigoEmbalage.filter(ce => ce.modelo == 'Experimental' && ce.tamanho == tamanho_da_sacaria)[0].codigo

        this.qua042CardIIIComponent.formulario.get("codigo_embalagem").setValue(codigo)
      }
    }

  }

  getForms(): FormGroup[] {
    const arrForms: Array<FormGroup> = new Array<FormGroup>();
    arrForms.push(this.qua042CardIComponent.formulario);
    arrForms.push(this.qua042CardIIComponent.formulario);
    arrForms.push(this.qua042CardIIIComponent.formulario);
    return arrForms;
  }

  validFormsToSave(): string {
    return this.formularioService.validForm(this.getForms());
  }

  cleanAll(): void {
    this.formularioService.cleanForm(this.getForms());
    this.qua042CardIComponent.formulario.get('centro_ensaque').setValue(this.generalService.getCentroEnsaqueByLocalStorageDataSite());
    //await this.getUser();
  }


  collapseAll(): void {
    this.btnCollapse = this.btnCollapse ? false : true;
    this.qua042CardIComponent.collapseCard = this.btnCollapse ? false : true;
    this.qua042CardIIComponent.collapseCard = this.btnCollapse ? false : true;
    this.qua042CardIIIComponent.collapseCard = this.btnCollapse ? false : true;
  }

  public buildFormulario(): void {
    this.formulario = this.formQua042.buildForm(this.formulario, this.getForms(), this.generalService);
  }

  private updateForm(data?: any): void {
    this.formulario.get('id').setValue(data.formulario.id);
    if (data.formulario.hasOwnProperty('offline')) {
      this.formulario.get('offline').setValue(true);
    }
    this.formQua042.updateForm(data, this.getForms(), this.generalService);

    this.qua042CardIComponent.disableNumeroCampo = true;
    this.qua042CardIComponent.safraBasicaOld = data.formulario.safra_basica;
    this.makeCalculations();
  }

  public calcQuantidadeDeEmablagens() {
    let total_embalagens = 0;
    const total_perdas_embalagens: number = !!this.qua042CardIIIComponent.formulario.get('total_perdas_embalagens')?.value ? this.qua042CardIIIComponent.formulario.get('total_perdas_embalagens')?.value as number : 0 ?? 0;
    const total_sacos: number = !!this.qua042CardIIIComponent.formulario.get('total_sacos')?.value ? this.qua042CardIIIComponent.formulario.get('total_sacos')?.value as number : 0 ?? 0;
    if (this.areaSelect.includes("Básica")) {
      const qntd_embalagem_canguru: number = !!this.qua042CardIIIComponent.formulario.get('qntd_embalagem_canguru')?.value ? this.qua042CardIIIComponent.formulario.get('qntd_embalagem_canguru')?.value as number : 0 ?? 0;
      total_embalagens = total_sacos + total_perdas_embalagens + qntd_embalagem_canguru;
    }
    else {
      total_embalagens = total_sacos + total_perdas_embalagens;
    }
    this.qua042CardIIIComponent.formulario.get('quantidade_embalagens_un').setValue(total_embalagens);
  }

  public getTotalPerdasEmbalagens(): void {
    let resultado: number = 0;
    let total_embalagens: number = 0;
    const total_sacos: number = !!this.qua042CardIIIComponent.formulario.get('total_sacos')?.value ? this.qua042CardIIIComponent.formulario.get('total_sacos')?.value as number : 0 ?? 0;
    const perdas_erro_impressao: number = !!this.qua042CardIIIComponent.formulario.get('perdas_embalagens_erro_impressao')?.value ? this.qua042CardIIIComponent.formulario.get('perdas_embalagens_erro_impressao')?.value as number : 0 ?? 0;
    const total_perdas_embalagens: number = !!this.qua042CardIIIComponent.formulario.get('total_perdas_embalagens')?.value ? this.qua042CardIIIComponent.formulario.get('total_perdas_embalagens')?.value as number : 0 ?? 0;
    // tslint:disable-next-line: max-line-length
    const perdas_erro_costura: number = !!this.qua042CardIIIComponent.formulario.get('perdas_embalagens_erro_costura')?.value ? this.qua042CardIIIComponent.formulario.get('perdas_embalagens_erro_costura')?.value as number : 0 ?? 0;
    const perdas_outras_ocorrencia: number = !!this.qua042CardIIIComponent.formulario.get('perdas_embalagens_outras_ocorrencias')?.value ? this.qua042CardIIIComponent.formulario.get('perdas_embalagens_outras_ocorrencias')?.value as number : 0 ?? 0;
    resultado = perdas_erro_impressao + perdas_erro_costura + perdas_outras_ocorrencia;

    if (this.areaSelect.includes("Básica")) {
      const perdas_erro_mensagem: number = !!this.qua042CardIIIComponent.formulario.get('perdas_embalagens_erro_mensagem')?.value ? this.qua042CardIIIComponent.formulario.get('perdas_embalagens_erro_mensagem')?.value as number : 0 ?? 0;
      resultado = resultado + perdas_erro_mensagem;
    } 

    this.qua042CardIIIComponent.formulario.get('total_perdas_embalagens').setValue(resultado);
  }

  private calcDuracaoAtvEnsaque(): void {
    // tslint:disable-next-line: max-line-length
    const inicioEnsaqueData: string = this.qua042CardIIIComponent.formulario.get('inicio_ensaque_data')?.value;
    const inicioEnsaqueHora: string = this.qua042CardIIIComponent.formulario.get('inicio_ensaque_hora')?.value;
    const terminoEnsaqueData: string = this.qua042CardIIIComponent.formulario.get('termino_ensaque_data')?.value;
    const terminoEnsaqueHora: string = this.qua042CardIIIComponent.formulario.get('termino_ensaque_hora')?.value;
    const rangeDateEnsaque: boolean = this.generalService.isValidRangeDate(inicioEnsaqueData, terminoEnsaqueData);
    const rangeHourEnsaque: boolean = this.generalService.isValidRangeHour(inicioEnsaqueHora, terminoEnsaqueHora, inicioEnsaqueData, terminoEnsaqueData);

    if (rangeDateEnsaque === true) {
      this.notificationService.sendNotification('', TypeMessage.InvalidRangeDate, ActionMessage.Error);
      // this.qua042CardIIIComponent.formulario.get('inicio_ensaque_data')?.setErrors({inicio_ensaque_data: true });
      this.qua042CardIIIComponent.formulario.get('termino_ensaque_data')?.setErrors({ termino_ensaque_data: true });
    }

    if (rangeHourEnsaque === true) {
      this.notificationService.sendNotification('', TypeMessage.InvalideRangeHour, ActionMessage.Error);
      // this.qua042CardIIIComponent.formulario.get('inicio_ensaque_data')?.setErrors({inicio_ensaque_data: true });
      this.qua042CardIIIComponent.formulario.get('termino_ensaque_hora')?.setErrors({ termino_ensaque_hora: true });

    }
    // tslint:disable-next-line: max-line-length
    if (inicioEnsaqueData?.length >= 8 && terminoEnsaqueData?.length >= 8 && inicioEnsaqueHora?.length > 0 && terminoEnsaqueHora?.length > 0) {
      const inicioEnsaque: Date = this.generalService.createDateTimeData(inicioEnsaqueData, inicioEnsaqueHora);
      const terminoEnsaque: Date = this.generalService.createDateTimeData(terminoEnsaqueData, terminoEnsaqueHora);
      // tslint:disable-next-line: max-line-length
      this.qua042CardIIIComponent.formulario.get('duracao_atividade_ensaque_h')?.setValue(this.generalService.timeDiffCalc(terminoEnsaque, inicioEnsaque));
    } else {
      this.qua042CardIIIComponent.formulario.get('duracao_atividade_ensaque_h')?.setValue(0);
    }
  }

  private calcPeneiraEGrupoPeneira(): void {
    const peneira = this.qua042CardIComponent.formulario.get('peneira')?.value ?? '';

    if (this.areaSelect.includes("Básica")) {
    return;
    }

  if (peneira.length > 2) {
  const grupoPeneira: string = peneira.slice(0, 2);
  this.qua042CardIComponent.formulario.get('grupo_peneira')?.setValue(grupoPeneira);
  }   else {
   this.qua042CardIComponent.formulario.get('grupo_peneira')?.setValue('');
  }
  }

  private calcTotalSacos(): void {
    let resultado: number = 0;
    const hibrido: string = this.qua042CardIComponent.formulario.get('hibrido_rnc')?.value;
    const peso: number = this.qua042CardIIIComponent.formulario.get('peso_sessenta_mil_sementes_impressao_kg')?.value;
    const sacos_ou_kg: number = this.qua042CardIIIComponent.formulario.get('qtde_sacos_ou_kg')?.value;
    const tipo_ensaque: string = this.qua042CardIComponent.formulario.get('tipo_ensaque')?.value;

    if (hibrido === 'AG1051' && peso == 5) {
      resultado = sacos_ou_kg / 4;
    } else if (tipo_ensaque === 'CS') {
      resultado = sacos_ou_kg / peso;
    } else {
      resultado = sacos_ou_kg;
    }
    this.qua042CardIIIComponent.formulario.get('total_sacos').setValue(resultado);
  }


  private calcPesoTotalDoLote(): void {
    const total_sacos: number = !!this.qua042CardIIIComponent.formulario.get('total_sacos')?.value ? this.qua042CardIIIComponent.formulario.get('total_sacos')?.value as number : 0 ?? 0;
    const peso: number = !!this.qua042CardIIIComponent.formulario.get('peso_sessenta_mil_sementes_impressao_kg')?.value ? this.qua042CardIIIComponent.formulario.get('peso_sessenta_mil_sementes_impressao_kg')?.value as number : 0 ?? 0;
    this.qua042CardIIIComponent.formulario.get('peso_total_lote_kg').setValue(total_sacos * peso);
  }



  public getCentroCampo(event?: any): void {
    const contratoJuridico: string = this.qua042CardIComponent.formulario.get('contrato_juridico')?.value;

    if (contratoJuridico?.length) {
      const regex = contratoJuridico.includes('-') ? /^([A-Z]{2,3})-?[A-Z]?\d{4}$/ : /^([A-Z]{1,2}\d)/
      const site = contratoJuridico.includes('-') ? contratoJuridico.match(regex)?.[1] : contratoJuridico.match(regex)?.[0];

      if (site && this.dict[site]) {
        const centro: string = this.dict[site];

        this.qua042CardIComponent.formulario.get('centro_campo').setValue(centro);

        if (centro === '1160' && this.areaSelect.includes('Básica')) {
          this.qua042CardIIComponent.show = false;
          this.disabledBasic();
        } else {
          this.qua042CardIIComponent.show = true;
          this.enabledBasic();
        }
      } else {
        this.qua042CardIComponent.formulario.get('centro_campo').setValue('');
        this.qua042CardIIComponent.show = true;
      }
    } else {
      this.qua042CardIComponent.formulario.get('centro_campo').setValue('');
      this.qua042CardIIComponent.show = true;
    }
  }

  public getEt004Data(event?: any): void {
    const controle_analise_et004 = this.qua042CardIIComponent.formulario.get('controle_analise_et004')?.value as string;
    const centro_ensaque = this.qua042CardIComponent.formulario.get('centro_ensaque')?.value as string;
    const safra = this.qua042CardIComponent.formulario.get('safra')?.value as string;

    if (!!controle_analise_et004 && !!safra && !!centro_ensaque) {
      this.formularioService.getEt004Data(controle_analise_et004, safra, centro_ensaque).pipe(take(1)).toPromise().then((objEt004: any) => {
        //this.qua042CardIComponent.formulario.get('peneira').setValue(objEt004?.data?.[0]);
        this.qua042CardIIComponent.formulario.get('tipo_tratamento').setValue(objEt004?.data?.[1]);
        this.qua042CardIIComponent.formulario.get('inicio_tratamento_data').setValue(this.generalService.convertStringToDateOrTimeOnly(objEt004?.data?.[2], true));
        this.qua042CardIIComponent.formulario.get('inicio_tratamento_hora').setValue(this.generalService.convertStringToDateOrTimeOnly(objEt004?.data?.[2], false));
        this.qua042CardIIComponent.formulario.get('termino_tratamento_data').setValue(this.generalService.convertStringToDateOrTimeOnly(objEt004?.data?.[3], true));
        this.qua042CardIIComponent.formulario.get('termino_tratamento_hora').setValue(this.generalService.convertStringToDateOrTimeOnly(objEt004?.data?.[3], false));

        // Calculo Duracao Atividade de Tratamento

        const inicioTratamentoData: string = this.qua042CardIIComponent.formulario.get('inicio_tratamento_data')?.value;
        const inicioTratamentoHora: string = this.qua042CardIIComponent.formulario.get('inicio_tratamento_hora')?.value;
        const terminoTratamentoData: string = this.qua042CardIIComponent.formulario.get('termino_tratamento_data')?.value;
        const terminoTratamentoHora: string = this.qua042CardIIComponent.formulario.get('termino_tratamento_hora')?.value;
        if (inicioTratamentoData?.length >= 8 && terminoTratamentoData?.length >= 8 && inicioTratamentoHora?.length > 0 && terminoTratamentoHora?.length > 0) {
          const inicioTratamento: Date = this.generalService.createDateTimeData(inicioTratamentoData, inicioTratamentoHora);
          const terminoTratamento: Date = this.generalService.createDateTimeData(terminoTratamentoData, terminoTratamentoHora);
          this.qua042CardIIComponent.formulario.get('duracao_atividade_tratamento_h').setValue(this.generalService.timeDiffCalc(terminoTratamento, inicioTratamento));
        } else {
          this.qua042CardIIComponent.formulario.get('duracao_atividade_tratamento_h').setValue(0);
        }

        // Calculo Grupo Peneira

        const peneira: string = this.qua042CardIComponent.formulario.get('peneira')?.value;
        if (peneira?.length >= 2) {
          const grupoPeneira: string = peneira.substr(0, 2);
          this.qua042CardIComponent.formulario.get('grupo_peneira').setValue(grupoPeneira);
        } else {
          this.qua042CardIComponent.formulario.get('grupo_peneira').setValue('');
        }


      }).catch(async (error: HttpErrorResponse) => {
        this.notificationService.showNotificationError(error, `Ocorreu um erro ao buscar os dados correspondentes ao seguinte Controle de Análise na ET004 ${controle_analise_et004}. Entre em contato com o Administrador.`);
      });
    }
  }

  public getPc003Data(event?: any): void {
    const contratoJuridico = this.qua042CardIComponent.formulario.get('contrato_juridico')?.value.trim()?.toUpperCase() as string;
    if (!!contratoJuridico) {
      const contrato = contratoJuridico.split(';')[0];
      this.formularioService.getPc003TorreData(contrato).pipe(take(1)).toPromise().then((objPc003: any) => {
        this.qua042CardIComponent.formulario.get('safra').setValue(objPc003?.data?.safra);
        this.qua042CardIComponent.formulario.get('hibrido_rnc').setValue(objPc003?.data?.hibrido_rnc);
        this.qua042CardIComponent.formulario.get('especie').setValue(objPc003?.data?.especie);
        this.qua042CardIIIComponent.formulario.get('status').setValue(objPc003?.data?.jit);
        this.getCentroCampo();

      }).catch(async (error: HttpErrorResponse) => {
        this.notificationService.showNotificationError(error, `Ocorreu um erro ao buscar os dados correspondentes ao contrato juridico ${contrato}. Entre em contato com o Administrador.`);
      });
    }
    //await this.calcCSouTB();
    this.getEt004Data();
  }

  /**
   * name
   */
  public disabledBasic() {
    this.qua042CardIIIComponent.formulario.get("inicio_ensaque_data").disable()
    this.qua042CardIIIComponent.formulario.get("inicio_ensaque_hora").disable()
    this.qua042CardIIIComponent.formulario.get("termino_ensaque_data").disable()
    this.qua042CardIIIComponent.formulario.get("termino_ensaque_hora").disable()
    this.qua042CardIIIComponent.formulario.get("silo_tratado_ou_psa").disable()
    this.qua042CardIComponent.formulario.get("silo_classificado_ou_big_bag").disable()
  }
  public enabledBasic() {
    this.qua042CardIIIComponent.formulario.get("inicio_ensaque_data").enable()
    this.qua042CardIIIComponent.formulario.get("inicio_ensaque_hora").enable()
    this.qua042CardIIIComponent.formulario.get("termino_ensaque_data").enable()
    this.qua042CardIIIComponent.formulario.get("termino_ensaque_hora").enable()
    this.qua042CardIIIComponent.formulario.get("silo_tratado_ou_psa").enable()
    this.qua042CardIComponent.formulario.get("silo_classificado_ou_big_bag").enable()
  }

  private async getUser(): Promise<void> {
    await this.formularioService.getUser().pipe(take(1)).toPromise().then(response => {
      this.currentUser = response['user-profile']?.displayName ?? 'Administrador';
    }).catch(async error => {
      await this.generalService.getUserNameValue().pipe(take(1)).toPromise().then((response: string) => {
        this.currentUser = response;
      }).catch(err => {
      });
    });
  }

  private fillCreatedByFormField(): void {
    this.qua042CardIIIComponent.formulario.get('criado_por').setValue(this.currentUser);
  }

  calcDatesEnsaque($event) {
    if (moment(this.qua042CardIIIComponent.formulario?.controls['data_conferencia_fisica'].value, "DD/MM/YYYY") < moment(this.qua042CardIComponent.formulario?.controls['data_ensaque'].value, "DD/MM/YYYY"))
      this.qua042CardIIIComponent.formulario?.controls['data_conferencia_fisica'].setErrors({ 'dateHighThanActual': true });
    else if (moment(this.qua042CardIIIComponent.formulario?.controls['data_conferencia_fisica'].value, "DD/MM/YYYY") >= moment(this.qua042CardIComponent.formulario?.controls['data_ensaque'].value, "DD/MM/YYYY"))
      this.qua042CardIIIComponent.formulario?.controls['data_conferencia_fisica'].setErrors(null);

    if (moment(this.qua042CardIIIComponent.formulario?.controls['data_hora_apontamento'].value, "DD/MM/YYYY") < moment(this.qua042CardIComponent.formulario?.controls['data_ensaque'].value, "DD/MM/YYYY"))
      this.qua042CardIIIComponent.formulario?.controls['data_hora_apontamento'].setErrors({ 'dateHighThanActual': true });
    else if (moment(this.qua042CardIIIComponent.formulario?.controls['data_hora_apontamento'].value, "DD/MM/YYYY") >= moment(this.qua042CardIComponent.formulario?.controls['data_ensaque'].value, "DD/MM/YYYY"))
      this.qua042CardIIIComponent.formulario?.controls['data_hora_apontamento'].setErrors(null);
  }
}